import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { UsedDataSourceItem } from './UsedDataSourceItem';
import { DataSource } from '@/models/dataSource';
import { Divider } from '@/components/divider';
import { isLastItemArray } from '@/utils/isLastItemArray';

interface IUsedDataSoureSection {
  datasources: DataSource[];
}

export const UsedDataSourceSection: FC<IUsedDataSoureSection> = ({ datasources }) => {
  const { t } = useTranslation('audience_details');

  return (
    <div>
      <p className='mb-2 inline-block text-base font-semibold text-brand-600'>{t('slideover.datasource_used')}</p>
      <div className='rounded-lg border border-quaternary-300 py-2.5'>
        {datasources.length > 0 ? (
          datasources.map((ds, i, arr) => (
            <Fragment key={ds.id}>
              <UsedDataSourceItem dataSource={ds} />
              {!isLastItemArray(i, arr) && <Divider dividerClassName='!mt-2.5 !mb-2.5' />}
            </Fragment>
          ))
        ) : (
          <p className='text-center text-base font-semibold text-gray-900'>{t('slideover.no_datasource_used')}</p>
        )}
      </div>
    </div>
  );
};
